export class FeatureOption{
  edition:string;
  availability:string;

  constructor(e:string, a:string) {
      this.edition = e;
      this.availability = a;
  }

}



// export enum Options{
//   STD = 0,
//   PRM = 1,
//   PRO = 2,
//   ENT = 3
// }
